import { opportunitiesApi } from '@modules/opportunities/entities/opportunity/api';
import { toast } from '@huspy/forge/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const convertKeyToFE = (key: string) => key.split('.').join('__');

const useGetMissingBankApplicationsFields = (
  opportunityId: string | undefined
) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['getMissingBankApplicationsFields', opportunityId],
    queryFn: () =>
      opportunitiesApi.getMissingBankApplicationsFields(opportunityId!),
    enabled: !!opportunityId,
    staleTime: 1_200_000,
    select: (response) =>
      response?.bank_applications_missing_data.map(
        (applicant) => ({
          ...applicant,
          missing_data: applicant.missing_data.map((appData) => ({
            ...appData,
            fields: appData.fields.map((field) => ({
              ...field,
              key: convertKeyToFE(field.key),
            })),
          })),
        })
      )
    ,
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useGetMissingBankApplicationsFields;
